<template>
  <div :class="itemClasses" @click="handleClick" @mousedown="handleMouseDown">
    <s-icon v-if="item.icon" :icon="item.icon" size="medium" :color="itemColor" />
    <transition>
      <div class="sidebar-item-text text-wrap" v-if="drawer">
        <span>{{ item.title }}</span>
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>

interface SidebarItemProps {
  item: Page;
  drawer: boolean;
  goToPage: (route: string) => void;
}

const props = defineProps<SidebarItemProps>();

const itemClasses = computed(() => ({
  'sidebar-item': true,
  'selected': props.item.active
}));

const itemColor = computed(() => props.item.active ? props.item.color : resolvedColor('base-icon'));

const handleClick = () => {
  props.goToPage(props.item.route);
};

const handleMouseDown = (event: MouseEvent) => {
  if (event.button === 1) { 
    window.open(props.item.route, '_blank');
  }
};
</script>
